module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/5Y3JE2/tc-custom/9781637610398.jpg?1699705937731",
      "alt": "This image is the cover for the book Myra and The Drawing Drama"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Myra and The Drawing Drama\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Myra is a 2nd grader with dreams of winning the school art contest and the adoration of the world. Judging from the grownups’ reactions, it looks like Myra’s dream is about to come true. Or is it? A funny, Almost True story about what happens when adults forget how to think like a kid. The day of the school’s art contest is here, and Myra can’t contain her excitement because this year she’s in it to win it!  After many tries, she creates her masterpiece and turns it in for review. The teacher’s reaction sets off a chain of events that take her (and the reader) on unexpected twists and turns. Based on a true story, this unconventional parable is a fun ride with a message that encourages empowerment through confidence, resourcefulness, and resilience.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rivera, Mario Menjivar, John Shableski\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Rosemary Rivera is a self-described Nuyorican nerd born and raised in The South Bronx. She’s lived many creative lives, beginning as a magazine writer and editor to working behind the scenes in network television at Telemundo and NBC, all the while creating ideas on the side. This included developing content for animated movies and TV shows with her partner, a former Disney animator, and illustrator. This book is one of their various collaborations.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Imagine & Wonder Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0